/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ScoreboardSummaryList = {
    properties: {
        scoreboards: {
    type: 'array',
    contains: {
        type: 'ScoreboardSummary',
    },
    isRequired: true,
},
    },
};